import { Link } from 'react-router-dom'
import { HeroPhoneLoop } from './HeroPhoneLoop'

/** Landing-v2 hero — two-column at md+: copy left, phone loop right.
 *  Wraps both columns in `.reveal` so the foundation hook fades them in on
 *  scroll. The pull-limit meta row keeps the freemium boundary visible
 *  without making it the loudest element in the section. */
export function Hero() {
  return (
    <section className="mx-auto grid max-w-[1280px] gap-12 px-5 pb-12 pt-20 md:grid-cols-[1.1fr_1fr] md:gap-16 md:px-8 md:pt-24">
      <div className="reveal">
        <p className="flex items-center gap-3 text-xs uppercase tracking-[0.3em] text-text-muted">
          <span className="relative inline-block h-1.5 w-1.5 rounded-full bg-rose">
            <span className="absolute inset-0 animate-ping rounded-full bg-rose/60" />
          </span>
          Live ceremonies for Cosmic members
        </p>
        <h1 className="mt-5 font-display text-5xl font-light italic md:text-6xl">
          A reading whenever you need one.
        </h1>
        <p className="mt-6 max-w-[36ch] text-text-secondary body">
          A small circle of creators — Sarah, Adrienne, and more joining over time — holding a daily practice you can open in a quiet moment.
        </p>
        <div className="mt-8 flex flex-wrap items-center gap-3">
          <Link
            to="/sign-up"
            className="rounded-md bg-gold px-5 py-2.5 text-sm font-medium text-cosmic-black shadow-glow-gold hover:bg-gold-light transition-colors"
          >
            Begin a reading
          </Link>
          <a
            href="#themes"
            className="rounded-md border border-hairline-strong px-5 py-2.5 text-sm text-text-secondary hover:text-text-primary hover:border-white/[0.16] transition-colors"
          >
            See what's inside
          </a>
        </div>
        <p className="mt-6 text-xs text-text-muted">
          🃏 One free pull a day · Cosmic unlocks the whole library
        </p>
      </div>
      <div className="reveal flex items-start justify-center md:justify-end">
        <HeroPhoneLoop />
      </div>
    </section>
  )
}
